import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import ContentHeader from '@components/_commons/ContentHeader';
import '@resources/assets/styles/video.scss';

function Video() {

    return (
        <div
            className='container-video wrapper-content'
            style={{
            }}
        >
            <div
                id="content-header"
                className="content-header"
            >
                <ContentHeader />
            </div>
            <div className="content-body wrapper-video" >
                <Outlet />
            </div>
        </div>
    );
}

export default Video;